module.exports = __webpack_public_path__ + "static/media/fm.59c5190c.svg";